import React, { useState } from 'react';

const faqs = [
  {
    question: 'How long until we go live?',
    answer:
      'Most pilots go live in about six weeks. The AI Audit in week one pins the scope and timeline, so you get a fixed date before we write any code.',
  },
  {
    question: 'What does it cost?',
    answer:
      'The fit call is free. The AI Audit is EUR 1,500 and is credited against the build. The build is fixed price, agreed in the AI Audit report. The run phase is a fixed monthly fee.',
  },
  {
    question: 'What do we get from the AI Audit?',
    answer:
      'An opportunity map, baseline metrics, compliance perimeter, reference architecture, and a recommended path, all in writing before you commit to a build.',
  },
  {
    question: 'Is our data safe?',
    answer:
      'Everything runs in your own cloud or VPC. We use zero-retention endpoints with OpenAI, Anthropic and Google. PII and PHI are redacted before any prompt leaves your environment. We sign a DPA and, where relevant, a BAA on every engagement.',
  },
  {
    question: 'Who owns what you build?',
    answer:
      'You do. Code, models, data, cloud infrastructure. No lock-in, no licence fees. You can stop at any step and keep everything we have built.',
  },
  {
    question: 'What happens after launch?',
    answer:
      'We stay on as your run partner: monitoring, monthly improvement reports, and updates as your usage grows. Many clients keep us as their ongoing AI team.',
  },
];

const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="section-padding bg-white">
      <div className="container-max">
        <div className="max-w-2xl mb-12">
          <h2 className="text-4xl md:text-5xl font-semibold text-black leading-[1.05] tracking-[-0.02em]">
            Frequently asked questions
          </h2>
        </div>

        <div className="max-w-3xl divide-y divide-neutral-200">
          {faqs.map((faq, i) => (
            <div key={i}>
              <button
                className="w-full flex items-center justify-between py-5 text-left gap-6 group"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                aria-expanded={openIndex === i}
              >
                <span className="text-base font-medium text-black group-hover:text-neutral-700 transition-colors">
                  {faq.question}
                </span>
                <svg
                  className={`w-5 h-5 text-neutral-400 shrink-0 transition-transform duration-200 ${
                    openIndex === i ? 'rotate-45' : ''
                  }`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M12 4v16m8-8H4" />
                </svg>
              </button>
              {openIndex === i && (
                <p className="pb-5 text-neutral-600 leading-relaxed text-[0.95rem]">
                  {faq.answer}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
